<template>
  <div class="allTabs mt-10">
    <v-row dense>
      <v-col cols="7" sm="9" md="10">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search anything here ..." single-line solo
          hide-details class="input-search"></v-text-field>
      </v-col>
      <v-col cols="5" sm="3" md="2">
        <v-select solo :items="slots" append-icon="mdi-chevron-down" label="Currency" class="custom-select"></v-select>
      </v-col>
    </v-row>
    <v-row dense class="mt-2">
      <v-col md="6" sm="6" lg="4" v-for="card in cards" :key="card.id">
        <v-card class="elevation-0 rounded-0 live-account-card" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
          <v-card-actions>
            <div class="trade-status">
              <div>
                <v-icon color="#647E98">{{ card.icon }}</v-icon>
              </div>
              <div class="trade-number">
                <span :class="card.textColor">{{ card.tradeTitle }}</span>
                <span>{{ card.tradeNumber }}</span>
              </div>
            </div>
            <v-spacer></v-spacer>
            <div class="trade-dropdown">
              <v-menu rounded="0" class="trade-dropdown-menu" transition="slide-x-transition" bottom left>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs" v-on="on" icon>
                    <v-icon :color="$vuetify.theme.dark ? '#fff' : '#162334'">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-card class="dropdown-menu-card" tile flat>
                  <v-list flat outlined :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'">
                    <v-list-item-group>
                      <v-list-item v-for="(item, i) in items" :key="i" :ripple="false" link>
                        <v-list-item-content>
                          <router-link v-text="item.text" class="text-decoration-none" router
                            :to="item.link"></router-link>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-menu>
            </div>
          </v-card-actions>
          <v-card-actions>
            <div class="value-trades mb-0">
              <span>{{ card.balanceSubtitle }}</span>
              <span>{{ card.balanceAmount }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value-trades mb-0">
              <span>{{ card.currencyTitle }}</span>
              <span>{{ card.currencyName }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
              <div>
                <apexChart width="100%" height="85px" type="line" :options="options" :series="series">
                </apexChart>
              </div>
            </v-sheet>
          </v-card-actions>
          <v-card-actions>
            <div class="currency-leverage">
              <span>{{ card.equityTitle }}</span>
              <span>{{ card.equityValue }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="currency-leverage">
              <span>{{ card.leverageTitle }}</span>
              <span>{{ card.leverageValue }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <div class="balance-equity">
              <span>{{ card.marginTitle }}</span>
              <span>{{ card.marginValue }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="balance-equity">
              <span>{{ card.accountTypeTitle }}</span>
              <span>{{ card.accountTypeValue }}</span>
            </div>
          </v-card-actions>
          <v-card-actions class="pb-0">
            <v-btn to="/live-account-details" block outlined class="blink"> See Details </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      slots: ["USD", "INR", "JPY"],
      items: [
        { text: "Deposit Funds", link: "/deposit" },
        { text: "Withdraw Funds", link: "/withdraw" },
        { text: "Internal Transfer", link: "/internal-transfer" },
        { text: "Change Trading Password", link: "/change-password" },
        { text: "Change Leverage", link: "/leverage" },
        { text: "Account Detail", link: "/trading-account-details" },
      ],
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
      cards: [
        {
          id: 1,
          textColor: "text-green",
          icon: "mdi-signal",
          tradeTitle: "MT5 - Real",
          tradeNumber: "10025987",
          balanceSubtitle: "Balance",
          balanceAmount: "500.00",
          currencyTitle: "currency",
          currencyName: "USD",
          equityTitle: "equity",
          equityValue: "5020.00",
          leverageTitle: "leverage",
          leverageValue: "500:1",
          marginTitle: "Free Margin",
          marginValue: "500.00",
          accountTypeTitle: "Acc. Type",
          accountTypeValue: "681462548",
        },
        {
          id: 2,
          textColor: "text-green",
          icon: "mdi-signal",
          tradeTitle: "MT5 - Real",
          tradeNumber: "10025987",
          balanceSubtitle: "Balance",
          balanceAmount: "500.00",
          currencyTitle: "currency",
          currencyName: "USD",
          equityTitle: "equity",
          equityValue: "5020.00",
          leverageTitle: "leverage",
          leverageValue: "500:1",
          marginTitle: "Free Margin",
          marginValue: "500.00",
          accountTypeTitle: "Acc. Type",
          accountTypeValue: "681462548",
        },
        {
          id: 3,
          textColor: "text-green",
          icon: "mdi-signal",
          tradeTitle: "MT5 - Real",
          tradeNumber: "10025987",
          balanceSubtitle: "Balance",
          balanceAmount: "500.00",
          currencyTitle: "currency",
          currencyName: "USD",
          equityTitle: "equity",
          equityValue: "5020.00",
          leverageTitle: "leverage",
          leverageValue: "500:1",
          marginTitle: "Free Margin",
          marginValue: "500.00",
          accountTypeTitle: "Acc. Type",
          accountTypeValue: "681462548",
        },
        {
          id: 4,
          textColor: "text-green",
          icon: "mdi-signal",
          tradeTitle: "MT5 - Real",
          tradeNumber: "10025987",
          balanceSubtitle: "Balance",
          balanceAmount: "500.00",
          currencyTitle: "currency",
          currencyName: "USD",
          equityTitle: "equity",
          equityValue: "5020.00",
          leverageTitle: "leverage",
          leverageValue: "500:1",
          marginTitle: "Free Margin",
          marginValue: "500.00",
          accountTypeTitle: "Acc. Type",
          accountTypeValue: "681462548",
        },
        {
          id: 5,
          textColor: "text-green",
          icon: "mdi-signal",
          tradeTitle: "MT5 - Real",
          tradeNumber: "10025987",
          balanceSubtitle: "Balance",
          balanceAmount: "500.00",
          currencyTitle: "currency",
          currencyName: "USD",
          equityTitle: "equity",
          equityValue: "5020.00",
          leverageTitle: "leverage",
          leverageValue: "500:1",
          marginTitle: "Free Margin",
          marginValue: "500.00",
          accountTypeTitle: "Acc. Type",
          accountTypeValue: "681462548",
        },
        {
          id: 6,
          textColor: "text-green",
          icon: "mdi-signal",
          tradeTitle: "MT5 - Real",
          tradeNumber: "10025987",
          balanceSubtitle: "Balance",
          balanceAmount: "500.00",
          currencyTitle: "currency",
          currencyName: "USD",
          equityTitle: "equity",
          equityValue: "5020.00",
          leverageTitle: "leverage",
          leverageValue: "500:1",
          marginTitle: "Free Margin",
          marginValue: "500.00",
          accountTypeTitle: "Acc. Type",
          accountTypeValue: "681462548",
        },
      ],
    };
  },
}
</script>

<style></style>